// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__khk5-","navText":"Navbar_navText__3EZRh","navLogo":"Navbar_navLogo__2kYWT","imgLogo":"Navbar_imgLogo__1c6dX"};